// extracted by mini-css-extract-plugin
module.exports = {"container":"PVGDpy-pt5iZZ7PE7WON_"};